import React, { useState, useRef, useEffect } from 'react';

const Forecast = ({ isOpen, onClose, onApply }) => {
  const [selectedProjectionTime, setSelectedProjectionTime] = useState('1m');
  const [includeNews, setIncludeNews] = useState(true);
  const [customScenario, setCustomScenario] = useState('');

  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const projectionTimeOptions = [
    { id: '1d', label: '1d' },
    { id: '1w', label: '1w' },
    { id: '1m', label: '1m' },
    { id: '3m', label: '3m' }
  ];

  const handleApply = () => {
    if (onApply) {
      onApply({
        horizon: selectedProjectionTime,
        includeNews,
        scenario: customScenario,
      });
    }
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="forecast-popup" ref={popupRef} style={{ position: 'absolute', top: '50px', right: '0', left: 'auto' }}>
      <h2 className="forecast-popup-title">Forecast</h2>

        {/* Projection Time */}
        <div className="forecast-section">
          <h3 className="forecast-section-title">Projection Time</h3>
          <div className="forecast-projection-pills">
            {projectionTimeOptions.map((option) => (
              <button
                key={option.id}
                onClick={() => setSelectedProjectionTime(option.id)}
                className={`forecast-projection-pill ${selectedProjectionTime === option.id ? 'active' : ''}`}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>

        {/* Include News */}
        <div className="forecast-section">
          <h3 className="forecast-section-title">Include News</h3>
          <div className="forecast-news-pills">
            <button
              onClick={() => setIncludeNews(true)}
              className={`forecast-news-pill ${includeNews ? 'active' : ''}`}
            >
              Include News
            </button>
            <button
              onClick={() => setIncludeNews(false)}
              className={`forecast-news-pill ${!includeNews ? 'active' : ''}`}
            >
              Not Include News
            </button>
          </div>
        </div>

        {/* Custom Scenario */}
        <div className="forecast-section">
          <h3 className="forecast-section-title">Custom Scenario</h3>
          <textarea
            className="forecast-textarea"
            placeholder="Describe a custom scenario which you would like to affect the AI forecast"
            value={customScenario}
            onChange={(e) => setCustomScenario(e.target.value)}
            rows={4}
          />
        </div>

        {/* Action Buttons */}
        <div className="forecast-actions">
          <button
            className="forecast-btn forecast-btn-cancel"
            onClick={handleCancel}
          >
            CANCEL
          </button>
          <button
            className="forecast-btn forecast-btn-apply"
            onClick={handleApply}
          >
            APPLY
          </button>
        </div>
    </div>
  );
};

export default Forecast;
